export const GET_USERS = 'GET_USERS';
export const GET_ADMIN_USERS = 'GET_ADMIN_USERS';
export const ADMIN_UPDATE_USER = 'ADMIN_UPDATE_USER';
export const DISABLE_USER = 'DISABLE_USER';
export const ADD_USER_ADMIN = 'ADD_USER_ADMIN';
